<!-- <section class="flex items-center h-100 p-16">
	<div class="container flex flex-col items-center justify-center px-5 mx-auto my-8">
		<div class="max-w-md text-center">
			<h2 class="mb-8 font-extrabold text-9xl dark:text-gray-400">
				<span class="sr-only">Error</span>404
			</h2>
			<p class="text-2xl font-semibold md:text-3xl">Sorry, we couldn't find this page.</p>
			<p class="mt-4 mb-8 dark:text-gray-600">But dont worry, you can find plenty of other things on our homepage.</p>
			<a routerLink="/home" rel="noopener noreferrer" class="px-8 py-3 font-semibold rounded bg-[#02578e] text-white">Back to homepage</a>
		</div>
	</div>
</section> -->
<!-- 404 page start -->
<div class="error-page-wrapper">
	<div class="content-wrapper">
		<span class="icon"><img src="assets/svgs/website-search-404.svg" alt="website icon"></span>
		<h1 class="title">OOPS! ERROR 404 NOT FOUND.</h1>
		<p class="text">The page you are looking for might have been removed had its name changed or is temporarily
			unavailable.</p>
		<a routerLink="/home" class="back-button">
			<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
				stroke="#ffffff">
				<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
				<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					<path fill-rule="evenodd" clip-rule="evenodd"
						d="M11.7071 4.29289C12.0976 4.68342 12.0976 5.31658 11.7071 5.70711L6.41421 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H6.41421L11.7071 18.2929C12.0976 18.6834 12.0976 19.3166 11.7071 19.7071C11.3166 20.0976 10.6834 20.0976 10.2929 19.7071L3.29289 12.7071C3.10536 12.5196 3 12.2652 3 12C3 11.7348 3.10536 11.4804 3.29289 11.2929L10.2929 4.29289C10.6834 3.90237 11.3166 3.90237 11.7071 4.29289Z"
						fill="#ffffff"></path>
				</g>
			</svg>
			BACK TO HOME
			PAGE</a>
	</div>
	<div class="error-bg-shape">
		<img src="assets/img/error-bg-404.jpeg" alt="error-bg">
	</div>
</div>
<!-- 404 page end -->